export default __webpack_public_path__ + "static/media/avatar.f0a6f791.svg";